var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.ContractTypesLoading)?_c('v-progress-linear',{attrs:{"indeterminate":"","height":"1"}}):_c('v-divider',{staticStyle:{"border-color":"rgb(151 151 151 / 12%)"}}),_vm._l((_vm.ContractTypeList),function(contractType,index){return _c('RouteListItem',{key:index,attrs:{"node":{
    name: 'Contracts',
    meta: {
      displayName: contractType.Name,
      icon: 'mdi-' + contractType.Icon,
      count: contractType.Count,
      params: { contractTypeId: contractType.Id },
    }
  }}})}),_c('v-divider',{staticClass:"mx-4",staticStyle:{"border-color":"rgb(151 151 151 / 12%)"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }